import { ts } from '_core';

// prepareDrawdownData
export const transform = (data: ts.types.widgets.TableData, isBasket: boolean, hasBenchmark: boolean) => {
  const newData = data.map((item) => {
    const newItem = { ...item } as ts.types.widgets.TableData[number];
    newItem[isBasket ? 'Basket Drawdown' : 'Portfolio Drawdown'] = item['return'];

    if (hasBenchmark && !isBasket) {
      newItem['Benchmark Drawdown'] = item['benchmark_returns'];
    }
    delete newItem['return'];
    delete newItem['benchmark_returns'];
    return newItem;
  });

  return newData;
};
